import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full p-4 mt-10 overflow-y-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center bold" }, "都道府県別の総人口推移グラフ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Bar = _resolveComponent("Bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Bar, {
      "chart-options": _ctx.chartOptions,
      "chart-data": _ctx.chartData,
      "chart-id": _ctx.chartId,
      "dataset-id-key": _ctx.datasetIdKey,
      width: _ctx.width,
      height: _ctx.height
    }, null, 8, ["chart-options", "chart-data", "chart-id", "dataset-id-key", "width", "height"])
  ]))
}